
import { ref } from 'vue'

import HeadingLv3 from '@/components/elements/HeadingLv3.vue'

import { axiosSetting } from '@/utils/axiosSetting'

export default {
  name: 'FaqCategories',
  components: {
    HeadingLv3
  },
  setup() {
    const categories = ref([])
    const ajax = axiosSetting('cms', 'block')

    const getCategories = () => {
      ajax
        .get(`${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/faq_category`)
        .then((res) => {
          categories.value = res.data
        })
    }

    getCategories()

    return {
      categories
    }
  }
}
